module.exports = __webpack_public_path__ + "img/industries-2.752eed9c.png";